import home1 from "../../assets/img/IMG-20251110-WA0036.jpg";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];
function VerticalTerrace() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="aboutWooden">
                <div className="fisherman-content">
                  <h3>🌿 Vertical & Terrace Gardening</h3>
                  <p>
                    In a world where urban living often means concrete walls,
                    narrow balconies and rooftops overlooked, vertical and
                    terrace gardening step in as creative lifelines for bringing
                    greenery home. A terrace that’s just a flat slab becomes a
                    rising garden; a bare balcony wall becomes a living tapestry
                    of vines and flowers. By using vertical supports,
                    wall‑mounted planters or lean‑in containers on a terrace,
                    you reclaim space that otherwise sits unused. In doing so,
                    you don’t just plant—you transform your everyday
                    surroundings into something softer, more alive.
                  </p>
                  <p>
                    There are genuine benefits to this kind of gardening that go
                    beyond just being “pretty”. For example, vertical gardens
                    help improve air quality by absorbing pollutants and
                    releasing oxygen — especially helpful in dense urban
                    settings. Gardeners Forest Gate +2 Ecocation +2 They also
                    maximize space: when you grow upwards rather than outwards,
                    you can fit more plants in less real estate. Ecocation +1 On
                    terraces, greenery offers extra perks: plants can shade
                    surfaces, reduce heat absorption, cool the environment, and
                    turn what was once an overlooked slab into somewhere you
                    love spending time. The how of it always matters. Begin by
                    observing your space: note how much sun you get, what
                    direction your walls face, how exposed your terrace is to
                    wind or weather. Choose the right structure: for a wall,
                    maybe a trellis or pockets; for a terrace, containers,
                    raised beds, and maybe a vertical element too. Use good soil
                    and ensure drainage—containers on terraces particularly must
                    let excess water out so roots don’t rot. One resource points
                    out how vertical gardens can dry out faster, so you must
                    plan your watering accordingly. Indoindians.com +1 Choose
                    plants suited to your location: if sun‑bathed, go for
                    sun‑lovers; if shaded, go for creepers, ferns or vines.
                  </p>
                 
                  
                </div> <div className="fisherman-content">
                  <h5>🌿 Ready to Elevate Your Green Space?</h5>
                  <p>
                    Our team transforms your rooftops and walls into lush,
                    sustainable green areas. Whether you want a veggie patch,
                    flower-filled terrace, or modern indoor green wall — we
                    bring your vision to life!
                  </p>
                  <a
                    className="commonButton mt-3"
                    href="mailto:info@example.com"
                  >
                    📧 Contact Us Today
                  </a>
                </div>
                {/* Lawn Development */}
                <div className="fisherman-content d-none">
                  <h5>🌱 Why Vertical & Terrace Gardening?</h5>
                  <ul>
                    <li>
                      <strong>Space-Saving:</strong> Ideal for urban homes,
                      apartments, and compact areas
                    </li>
                    <li>
                      <strong>Thermal Insulation:</strong> Reduces rooftop heat
                      and improves indoor cooling
                    </li>
                    <li>
                      <strong>Air Purification:</strong> Plants help absorb
                      pollutants and improve air quality
                    </li>
                    <li>
                      <strong>Aesthetic Appeal:</strong> Turns dull walls and
                      rooftops into green retreats
                    </li>
                    <li>
                      <strong>Grow Your Own:</strong> Cultivate herbs,
                      vegetables, and ornamentals at home
                    </li>
                    <li>
                      <strong>Promotes Mental Wellness:</strong> Engaging,
                      rewarding, and therapeutic activity
                    </li>
                  </ul>
                </div>
                <div className="fisherman-content d-none">
                  <h5>🪴 Types of Vertical Gardens</h5>
                  <ul>
                    <li>
                      🧱 Wall-mounted planters (modular panels, pouches, frames)
                    </li>
                    <li>🧺 Hanging baskets and shelves</li>
                    <li>🪟 Trellis systems for climbing plants</li>
                    <li>🛖 Recycled bottle or pallet planters</li>
                    <li>🌿 Indoor vertical green walls with irrigation</li>
                  </ul>
                </div>
               
              </div>
            </div>
            <div className="col-lg-12 mt-5">
              {/* Terrace Garden Essentials */}
              <div className="fisherman-content d-none">
                <h4>🌼 Essentials of Terrace Gardening</h4>
                <ul>
                  <li>
                    🪵 Raised beds or large pots for vegetables and flowers
                  </li>
                  <li>
                    🛠️ Waterproofing and drainage to protect the structure
                  </li>
                  <li>
                    💧 Efficient irrigation (drip systems or hand watering)
                  </li>
                  <li>🌱 Soil mix rich in compost and organic matter</li>
                  <li>☀️ Choose plants based on sunlight availability</li>
                  <li>
                    🌾 Popular choices: tomatoes, mint, chillies, lettuce,
                    roses, jasmine
                  </li>
                </ul>
              </div>
              {/* Our Services */}
              <div className="fisherman-content d-none">
                <h4>🛠️ Our Vertical &amp; Terrace Gardening Services</h4>
                <ul>
                  <li>Rooftop garden design and waterproofing</li>
                  <li>Vertical garden installations (indoor/outdoor)</li>
                  <li>Custom soil and planter selection</li>
                  <li>Irrigation system setup</li>
                  <li>Herbal, vegetable, and ornamental garden planning</li>
                  <li>Maintenance and seasonal care plans</li>
                  <li>Green wall solutions for offices and homes</li>
                </ul>
              </div>
              {/* Call to Action */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default VerticalTerrace;
